<template>
  <v-container fluid>
    <v-row>
      <v-col class="mt-5">
        <div>
          <v-data-table
            :headers="headers"
            :items="items"
            item-key="id"
            height="70vh"
            class="v-data-table-outlined"
            fixed-header
            disable-pagination
            hide-default-footer
            mt-5
          >
            <template v-slot:[`items.groupNm`]="{ item }">
              <span>
                {{ item.groupNm.groupNm }}
              </span>
            </template>
            <template v-slot:[`item.modify`]="{ item }">
              <v-btn
                icon
                @click="clickModify(item.id, item.model_id, item.serial_no, item.groupNm.groupNm, item.optional_info_2)"
                color="green"
                class="icon"
                fab
                small
                dark
              >
                <v-icon>mdi-circle-edit-outline</v-icon>
              </v-btn>
            </template>
          </v-data-table>
          <!-- 編集モーダルここから -->
          <v-dialog v-model="first" width="500">
            <v-form v-model="dialogeditvalid" @submit.prevent="editSave(editGroupName)" ref="editForm">
              <v-card>
                <v-card-title class="headline grey lighten-2">
                  {{ $t('edit') }}
                </v-card-title>
                <v-col cols="12">
                  <v-text-field
                    :label="$t('customerSMachineNo')"
                    outlined
                    v-model="editConsumerId"
                    :rules="
                      countValid({
                        num: 40,
                        msg1: $t('requiredField'),
                        msg2: $t('pleaseEnterWithinCharacters', { num: 40 }),
                      })
                    "
                    required
                  ></v-text-field>
                  <v-select
                    v-model="editGroupName"
                    :items="groups"
                    item-value="value"
                    :label="$t('groupName')"
                    item-text="groupName"
                    return-object
                    outlined
                    block
                  ></v-select>
                </v-col>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text type="submit" :disabled="!dialogeditvalid">
                    {{ $t('save') }}
                  </v-btn>
                  <v-btn color="primary" text @click="editClose">
                    {{ $t('cancel') }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-dialog>
          <!-- 編集モーダルここまで -->
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  // import moment from 'moment'
  // import modelMapping from '../resources/model_mapping.json'
  import { mapGetters } from 'vuex';
  export default {
    title() {
      return this.$t(this.$route.meta.title);
    },
    name: 'Table',
    components: {},
    data: () => ({
      headers: [],
      items: [],
      arr: '',
      groups: [],
      first: false,
      editDataId: '',
      editModelId: '',
      editSerialNo: '',
      editGroupName: '',
      editConsumerId: '',
      deviceGroupID: '',
      deviceItem: '',
      devices: '',
      mailid: '',
      dialogeditvalid: true,
    }),
    methods: {
      async getItems() {
        this.$store.commit('loading/start_loading');
        let item = [];
        // const groupDevices=[]
        let flag = false;
        let itemDatas = [];
        //Api用のユーザーのdeviceGroupIdをセット
        const params = {
          deviceGroupId: this.user_info.deviceGroupId,
        };
        console.log(params);
        //getGropsでユーザーの登録したグループをAzureから取得
        this.groups = await this.azureRequest('/api/getGroups', 'GET', params);
        this.groups.map((item) =>
          Object.assign(item, {
            value: item.groupName,
          })
        );
        console.log(this.groups);
        let itemLength = 0;
        //Apiで取得してきたグループのデータを1件ずつ回す
        if (this.groups.length != 0) {
          for (let i = 0; i < this.groups.length; i++) {
            //Apiで取得してきたグループのdeviceIdsの中に登録されているmodel_id,serial_noの数が0でないときに処理を続ける
            if (this.groups[i].devices.length != 0) {
              //Apiで取得してきたグループのdeviceIdsの中に登録されているデバイスIDの数で回す
              for (let j = 0; j < this.groups[i].devices.length; j++) {
                //Apiで取得してきたグループのdeviceIdsの中に登録されているデバイスIDの数で東芝DBからdevicesの情報を取得する
                const devices = await this.apiRequest('/v1/master-info/devices', 'GET', {
                  model_id: this.groups[i].devices[j].modelId,
                  serial_no: this.groups[i].devices[j].serialNo,
                });
                if (devices && devices.length > 0) {
                  //東芝DBから取得してきたユーザーのserial_noの「_」の前の文字列を取得する
                  const serialNo = devices[0].serial_no.substring(0, devices[0].serial_no.indexOf('_'));
                  //const itemに取得してきたAzureに登録されているdevicesのデータにグループ名、グループIDを一緒に追加する
                  item[itemLength] = devices.map((item) =>
                    Object.assign(item, {
                      serial_no_edit: serialNo,
                      groupNm: {
                        groupNm: this.groups[i].groupName,
                        id: this.groups[i].id,
                      },
                    })
                  );
                  itemLength++;
                }
              }
            }
          }
          // this.items=item
          itemLength = 0;
          const userDeviceAuthorities = await this.getUserDeviceAuthorities();
          //deviceGroupIdで取得した東芝DBのuserDeviceAuthoritiesのデータが0でなくとき処理を実行する
          if (userDeviceAuthorities.length != 0) {
            for (let a = 0; a < userDeviceAuthorities.length; a++) {
              //Apiで取得した東芝DBのuserDeviceAuthoritiesのmodel_idとserial_noで
              this.devices = await this.apiRequest('/v1/master-info/devices', 'GET', {
                model_id: userDeviceAuthorities[a].model_id,
                serial_no: userDeviceAuthorities[a].serial_no,
              });
              //すでにv-data-tableの中にデータがあるか確認する
              if (item.length != 0) {
                //すでにv-data-tableの中にデータを1つずつ回す
                for (let b = 0; b < item.length; b++) {
                  // if(item[b][0].groupNm.groupNm!=''){
                  //すでにv-data-tableの中にあるデータ
                  //「i」はApiで所得したAzureにあるグループの長さ
                  //「j」はApiで所得したAzureにあるグループのdeviceIdsの長さ
                  for (let r = 0; r < item.length; r++) {
                    if (item[r][0].id === this.devices[0].id) {
                      flag = true;
                    }
                  }
                  if (flag === false) {
                    itemDatas = [];
                    const serialNo = this.devices[0].serial_no.substring(0, this.devices[0].serial_no.indexOf('_'));
                    itemDatas = this.devices.map((data) =>
                      Object.assign(data, {
                        serial_no_edit: serialNo,
                        groupNm: {
                          groupNm: '',
                          id: '',
                        },
                      })
                    );
                  }
                  // }
                  flag = false;
                }
                if (itemDatas.length != 0) {
                  const M = item.length;
                  item[M] = itemDatas;
                  itemDatas = [];
                }
              } else {
                //すでにv-data-tableの中にデータがないとき、v-data-tableに東芝DBのdeviceのデータを追加する
                const serialNo = this.devices[0].serial_no.substring(0, this.devices[0].serial_no.indexOf('_'));
                item[a] = this.devices.map((data) =>
                  Object.assign(data, {
                    serial_no_edit: serialNo,
                    groupNm: {
                      groupNm: '',
                      id: '',
                    },
                  })
                );
              }
            }
            // すでにv-data-tableの中にデータがないとき、v-data-tableに東芝DBのdeviceのデータを追加する
            for (let len = 0; len < item.length; len++) {
              item[len] = item[len][0];
            }
            //機械情報のidを基準にして昇順でソートする
            let smoll = 0;
            for (let h = 0; h < item.length; h++) {
              for (let g = h + 1; g < item.length; g++) {
                if (item[h].id > item[g].id) {
                  smoll = item[h];
                  item[h] = item[g];
                  item[g] = smoll;
                }
              }
            }
            this.items = item;
          }
        } else {
          const userDeviceAuthorities = await this.getUserDeviceAuthorities();
          //deviceGroupIdで取得した東芝DBのuserDeviceAuthoritiesのデータが0でなくとき処理を実行する
          if (userDeviceAuthorities.length != 0) {
            for (let a = 0; a < userDeviceAuthorities.length; a++) {
              //Apiで取得した東芝DBのuserDeviceAuthoritiesのmodel_idとserial_noで
              this.devices = await this.apiRequest('/v1/master-info/devices', 'GET', {
                model_id: userDeviceAuthorities[a].model_id,
                serial_no: userDeviceAuthorities[a].serial_no,
              });
              //すでにv-data-tableの中にデータがあるか確認する
              if (item.length != 0) {
                //すでにv-data-tableの中にデータを1つずつ回す
                for (let b = 0; b < item.length; b++) {
                  // if(item[b][0].groupNm.groupNm!=''){
                  //すでにv-data-tableの中にあるデータ
                  //「i」はApiで所得したAzureにあるグループの長さ
                  //「j」はApiで所得したAzureにあるグループのdeviceIdsの長さ
                  for (let r = 0; r < item.length; r++) {
                    if (item[r][0].id === this.devices[0].id) {
                      flag = true;
                    }
                  }
                  if (flag === false) {
                    itemDatas = [];
                    const serialNo = this.devices[0].serial_no.substring(0, this.devices[0].serial_no.indexOf('_'));
                    itemDatas = this.devices.map((data) =>
                      Object.assign(data, {
                        serial_no_edit: serialNo,
                        groupNm: {
                          groupNm: '',
                          id: '',
                        },
                      })
                    );
                  }
                  // }
                  flag = false;
                }
                if (itemDatas.length != 0) {
                  const M = item.length;
                  item[M] = itemDatas;
                  itemDatas = [];
                }
              } else {
                //すでにv-data-tableの中にデータがないとき、v-data-tableに東芝DBのdeviceのデータを追加する
                const serialNo = this.devices[0].serial_no.substring(0, this.devices[0].serial_no.indexOf('_'));
                item[a] = this.devices.map((data) =>
                  Object.assign(data, {
                    serial_no_edit: serialNo,
                    groupNm: {
                      groupNm: '',
                      id: '',
                    },
                  })
                );
              }
            }
            // すでにv-data-tableの中にデータがないとき、v-data-tableに東芝DBのdeviceのデータを追加する
            for (let len = 0; len < item.length; len++) {
              item[len] = item[len][0];
            }
            //機械情報のidを基準にして昇順でソートする
            let smoll = 0;
            for (let h = 0; h < item.length; h++) {
              for (let g = h + 1; g < item.length; g++) {
                if (item[h].id > item[g].id) {
                  smoll = item[h];
                  item[h] = item[g];
                  item[g] = smoll;
                }
              }
            }
            this.items = item;
          }
        }
        const emptyGroupName = {
          id: 1,
          groupName: '-----------',
          value: '',
        };
        this.groups.unshift(emptyGroupName);

        console.log(this.groups);
        this.$store.commit('loading/end_loading');
      },
      //東芝DBからdeviceGroupsをdeviceGroupIdで取得する
      async getDeviceGroups() {
        const deviceGroups = await this.apiRequest('/v1/master-info/deviceGroups', 'GET', {
          device_group_id: this.user_info.deviceGroupId,
        });
        return deviceGroups[0];
      },
      //東芝DBからuserDeviceAuthoritiesをdeviceGroupIdで取得する
      async getUserDeviceAuthorities() {
        const userDeviceAuthorities = await this.apiRequest('/v1/master-info/userDeviceAuthorities', 'GET', {
          device_group_id: this.user_info.deviceGroupId,
          sort: 'optional_info_2,serial_no',
        });
        return userDeviceAuthorities;
      },
      clickModify(id, ModelId, SerialNo, groupNm, consumerId) {
        this.first = true;
        this.editModelId = ModelId;
        this.editSerialNo = SerialNo;
        this.editDataId = id;
        this.editGroupName = groupNm;
        this.editConsumerId = consumerId;
      },
      async editSave(groups) {
        this.first = !this.first;
        let beforeDevaiceIdList = [];
        let afterDevaiceIdList = [];
        let requestBodyPut = '';
        const beforGroupName = this.items.filter((item) => item.id === this.editDataId)[0].groupNm.groupNm;
        if (this.items.filter((item) => item.id === this.editDataId)[0].mailId === undefined) {
          this.mailid = [];
        } else {
          this.mailid = this.items.filter((item) => item.id === this.editDataId)[0].mailId;
        }
        console.log(this.items.filter((item) => item.id === this.editDataId)[0].mailId);
        //groupsが変更されたかどうかを確認する
        if (groups.devices != undefined) {
          if (beforGroupName === '') {
            //グループ名が登録されていないか確認する
            afterDevaiceIdList = groups.devices;
            // const num=afterDevaiceIdList.length
            let abbdata = [];
            afterDevaiceIdList = groups.devices;
            abbdata = {
              modelId: this.items.filter((item) => item.id === this.editDataId)[0].model_id,
              serialNo: this.items.filter((item) => item.id === this.editDataId)[0].serial_no,
            };
            afterDevaiceIdList.push(abbdata);
            requestBodyPut = {
              id: groups.id,
              groupName: groups.groupName,
              devices: afterDevaiceIdList,
              deviceGroupId: this.user_info.deviceGroupId,
              updaterId: this.user_info.userId,
              mailId: this.mailid,
            };
            await this.azureRequest(`/api/putGroups`, 'PUT', requestBodyPut);
            this.items.filter((item) => item.id === this.editDataId)[0].groupNm.groupNm = groups.groupName;
            this.items.filter((item) => item.id === this.editDataId)[0].groupNm.id = groups.id;
            this.items.filter((item) => item.id === this.editDataId)[0].optional_info_2 = this.editConsumerId;
          } else if (beforGroupName != groups.groupName && groups.groupName != '-----------') {
            //変更されたグループ名のgroupsに登録されているdevaicesにmodel_id,serial_noを追加する

            let abbdata = [];
            afterDevaiceIdList = groups.devices;
            abbdata = {
              modelId: this.items.filter((item) => item.id === this.editDataId)[0].model_id,
              serialNo: this.items.filter((item) => item.id === this.editDataId)[0].serial_no,
            };
            afterDevaiceIdList.push(abbdata);
            //変更前のグループのdevicesの更新を行う
            const beforeGroupId = this.items.filter((item) => item.id === this.editDataId)[0].groupNm.id;
            for (let m = 0; m < this.groups.length; m++) {
              if (this.groups[m].id === beforeGroupId) {
                const group = this.groups[m];
                if (group.devices.length != 1) {
                  for (let s = 0; s < group.devices.length; s++) {
                    if (
                      group.devices[s].modelId === this.editModelId &&
                      group.devices[s].serialNo === this.editSerialNo
                    ) {
                      group.devices.splice(s, 1);
                    }
                  }
                } else if (group.devices.length === 1) {
                  group.devices.splice(0, 1);
                }
                beforeDevaiceIdList = group.devices;
              }
            }
            const removeGroupName = this.items.filter((item) => item.id === this.editDataId)[0].groupNm.groupNm;
            //新たに変更されたグループのdevicesにdeviceを追加するための配列
            const plusRequestBodyPut = {
              id: groups.id,
              groupName: groups.groupName,
              devices: afterDevaiceIdList,
              deviceGroupId: this.user_info.deviceGroupId,
              updaterId: this.user_info.userId,
              mailId: this.mailid,
            };
            //変更されたグループのdevicesのmodelId,serialNoを取り除くための配列
            const removeRequestBodyPut = {
              id: beforeGroupId,
              groupName: removeGroupName,
              devices: beforeDevaiceIdList,
              deviceGroupId: this.user_info.deviceGroupId,
              updaterId: this.user_info.userId,
              mailId: this.mailid,
            };
            await this.azureRequest(`/api/putGroups`, 'PUT', plusRequestBodyPut);
            await this.azureRequest(`/api/putGroups`, 'PUT', removeRequestBodyPut);
            this.items.filter((item) => item.id === this.editDataId)[0].groupNm.groupNm = groups.groupName;
            this.items.filter((item) => item.id === this.editDataId)[0].groupNm.id = groups.id;
            this.items.filter((item) => item.id === this.editDataId)[0].optional_info_2 = this.editConsumerId;
          } else if (beforGroupName === groups.groupName && groups.groupName != '-----------') {
            console.log('(´・ω・)2');
            const groupId = this.items.filter((item) => item.id === this.editDataId)[0].groupNm.id;
            const gorupNm = this.items.filter((item) => item.id === this.editDataId)[0].groupNm.groupNm;
            const SomeDevaices = this.groups.filter((item) => item.id === groupId)[0].devices;
            // 同じグループ名で更新されたときの処理
            requestBodyPut = {
              id: groupId,
              groupName: gorupNm,
              devices: SomeDevaices,
              deviceGroupId: this.user_info.deviceGroupId,
              updaterId: this.user_info.userId,
              mailId: this.mailid,
            };
            await this.azureRequest(`/api/putGroups`, 'PUT', requestBodyPut);
            this.items.filter((item) => item.id === this.editDataId)[0].groupNm.groupNm = groups.groupName;
            this.items.filter((item) => item.id === this.editDataId)[0].groupNm.id = groups.id;
            this.items.filter((item) => item.id === this.editDataId)[0].optional_info_2 = this.editConsumerId;
          }
        } else if (groups.groupName === '-----------') {
          if (beforGroupName != '') {
            const beforeGroupId = this.items.filter((item) => item.id === this.editDataId)[0].groupNm.id;
            const removeGroupName = this.items.filter((item) => item.id === this.editDataId)[0].groupNm.groupNm;
            const devices = this.groups.filter((item) => item.id === beforeGroupId)[0].devices;
            console.log(this.editSerialNo);
            if (devices.length > 0) {
              for (let s = 0; s < devices.length; s++) {
                if (devices[s].modelId === this.editModelId && devices[s].serialNo === this.editSerialNo) {
                  console.log(
                    devices[s].modelId + '/' + this.editModelId,
                    devices[s].serialNo + '/' + this.editSerialNo
                  );
                  devices.splice(s, 1);
                }
              }
            } else if (devices.length === 1) {
              devices.splice(0, 1);
            }
            beforeDevaiceIdList = devices;
            const removeRequestBodyPut = {
              id: beforeGroupId,
              groupName: removeGroupName,
              devices: beforeDevaiceIdList,
              deviceGroupId: this.user_info.deviceGroupId,
              updaterId: this.user_info.userId,
              mailId: this.mailid,
            };
            console.log(removeRequestBodyPut);
            await this.azureRequest(`/api/putGroups`, 'PUT', removeRequestBodyPut);
          } else {
            this.items.filter((item) => item.id === this.editDataId)[0].groupNm.groupNm = '';
            this.items.filter((item) => item.id === this.editDataId)[0].groupNm.id = '';
            this.items.filter((item) => item.id === this.editDataId)[0].optional_info_2 = this.editConsumerId;
          }
        }
        //ここで東芝API叩いてお客様管理番号の保存
        const filtersItem = this.items.filter((item) => item.id === this.editDataId);
        const requestBodyput = {
          communication_flg: filtersItem[0].communication_flg,
          description_locale1: filtersItem[0].description_locale1,
          description_locale2: filtersItem[0].description_locale2,
          description_locale3: filtersItem[0].description_locale3,
          device_mode: filtersItem[0].device_mode,
          device_type: filtersItem[0].device_type,
          id: this.editDataId,
          insert_time: filtersItem[0].insert_time,
          inserted: filtersItem[0].inserted,
          iot_device_flg: filtersItem[0].iot_device_flg,
          latitude: filtersItem[0].latitude,
          longitude: filtersItem[0].longitude,
          maker_code: filtersItem[0].maker_code,
          model_id: filtersItem[0].model_id,
          name_locale1: filtersItem[0].name_locale1,
          name_locale2: filtersItem[0].name_locale2,
          name_locale3: filtersItem[0].name_locale3,
          note: filtersItem[0].note,
          optional_info_1: filtersItem[0].optional_info_1,
          optional_info_10: filtersItem[0].optional_info_10,
          optional_info_2: this.editConsumerId,
          optional_info_3: filtersItem[0].optional_info_3,
          optional_info_4: filtersItem[0].optional_info_4,
          optional_info_5: filtersItem[0].optional_info_5,
          optional_info_6: filtersItem[0].optional_info_6,
          optional_info_7: filtersItem[0].optional_info_7,
          optional_info_8: filtersItem[0].optional_info_8,
          optional_info_9: filtersItem[0].optional_info_9,
          parent_model_id: filtersItem[0].parent_model_id,
          parent_serial_no: filtersItem[0].parent_serial_no,
          serial_no: filtersItem[0].serial_no,
          setup_place: filtersItem[0].setup_place,
          setup_status: filtersItem[0].setup_status,
          time_zone: filtersItem[0].time_zone,
          unreceive_seconds: filtersItem[0].unreceive_seconds,
          update_time: filtersItem[0].update_time,
          version: filtersItem[0].version,
        };
        if (groups.groupName != undefined) {
          this.items.filter((item) => item.id === this.editDataId)[0].groupNm.groupNm = groups.groupName;
        } else {
          this.items.filter((item) => item.id === this.editDataId)[0].groupNm.groupNm = groups;
        }
        await this.apiRequest('/v1/master-info/devices/' + this.editDataId, 'PUT', requestBodyput);
        this.items.filter((item) => item.id === this.editDataId)[0].optional_info_2 = this.editConsumerId;
        this.getItems();
      },
      editClose() {
        this.first = !this.first;
      },
    },
    computed: {
      ...mapGetters('auth', ['user_info']),
      countValid: () => (val) => [(v) => !v || v.length <= val.num || val.msg2],
      validation: function (editConsumerId) {
        if (editConsumerId.length > 40) {
          return true;
        } else {
          return false;
        }
      },
    },
    mounted() {},
    created() {
      this.getItems();
      this.headers = [
        {
          text: this.$t('serialNo'),
          align: 'start',
          value: 'serial_no_edit',
          class: 'info-alerm-table-header',
          sortable: false,
        },
        {
          text: this.$t('customerSMachineNo'),
          align: 'start',
          value: 'optional_info_2',
          class: 'info-alerm-table-header',
          sortable: false,
        },
        {
          text: this.$t('model'),
          align: 'start',
          value: 'optional_info_1',
          class: 'info-alerm-table-header',
          sortable: false,
        },
        {
          text: this.$t('groupName'),
          align: 'start',
          value: 'groupNm.groupNm',
          class: 'info-alerm-table-header',
          sortable: false,
        },
        { text: this.$t('edit'), align: 'start', value: 'modify', class: 'info-alerm-table-header', sortable: false },
      ];
    },
  };
</script>
<style>
  .SaveBtn {
    position: absolute;
    left: 77vw;
    margin-top: 3vw;
  }
  .v-icon.notranslate.labelcolor.material-icons.theme--light {
    color: #ffffff;
  }
  .saveBtnColor.v-btn.v-btn--is-elevated.v-btn--has-bg.theme--light.v-size--default {
    background-color: #09194f;
  }
  .span {
    margin-top: 7vw;
  }
  .TableStyleHeaderLast {
    background-color: #d3e6ff;
  }
  .TableStyleHeader {
    background-color: #d3e6ff;
  }
  .mdi-plus-circle::before {
    font-size: 40px;
  }
  .mdi-minus-circle::before {
    font-size: 40px;
  }
  .primary {
    background-color: #ffff;
  }
  .mdi-check-circle-outline::before {
    font-size: 30px;
  }
  .display {
    display: block;
  }
</style>
